const prod = true
export const PRODUCT_SERVICE = prod ? "https://stores.heyu.asia" : "http://103.63.109.25:2026"
